import { render, staticRenderFns } from "./conferenceInfo.vue?vue&type=template&id=f7aca0d6&scoped=true&lang=pug"
import script from "./conferenceInfo.vue?vue&type=script&lang=js"
export * from "./conferenceInfo.vue?vue&type=script&lang=js"
import style0 from "./conferenceInfo.vue?vue&type=style&index=0&id=f7aca0d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7aca0d6",
  null
  
)

export default component.exports